/**
 * Export Data Page JavaScript
 * Handles dynamic form options based on selected export type
 */

$(document).ready(function() {
    // SECURITY CHECK: Only run if we're on the export data page
    if ($('#export-data-form').length === 0 || $('[data-page="export-data"]').length === 0) {
        // Not on export data page - don't initialize anything!
        return;
    }
    
    // Hide all specific option sections on page load
    $('.export-type-options').hide();
    
    // Handle export type change - SPECIFIC to export form
    $('#export_type').on('change', function() {
        const selectedType = $(this).val();
        
        // Hide all option sections first - ONLY export options
        $('#export-data-form .export-type-options').hide();
        
        // Show relevant section based on selection
        if (selectedType === 'events') {
            $('#events-options').show();
        } else if (selectedType === 'members') {
            $('#members-options').show();
        } else if (selectedType === 'songs') {
            $('#songs-options').show();
        }
    });
    
    // Handle "all events" checkbox for events export
    $('#all_events').on('change', function() {
        if ($(this).is(':checked')) {
            $('#events-date-range').hide();
        } else {
            $('#events-date-range').show();
        }
    });
    
    // Initialize state on page load
    $('#all_events').trigger('change');
    
    // Export form handling - ONLY for the specific export form
    let pollingInterval = null;
    let currentJobId = null;
    let isSubmitting = false; // Race condition protection
    let pollingAttempts = 0; // Timeout protection
    const MAX_POLLING_ATTEMPTS = 40; // 40 × 3s = 2 minutes max
    
    // Clear any stale polling on page load to prevent confusion
    if (pollingInterval) {
        clearInterval(pollingInterval);
        pollingInterval = null;
    }
    
    // Override form submission to use AJAX - VERY SPECIFIC SELECTOR!
    $('#export-data-form').on('submit', function(e) {
        e.preventDefault(); // Prevent normal form submission
        
        // Prevent race condition from double-clicking
        if (isSubmitting) {
            return false;
        }
        isSubmitting = true;
        
        // Clean up any previous export file before starting new export
        cleanupPreviousExport();
        
        const formData = new FormData(this);
        const submitButton = $('#export-submit-btn'); // Very specific button
        
        // Disable submit button and show loading
        submitButton.prop('disabled', true)
                   .html('<i class="mdi mdi-loading mdi-spin me-1"></i>Rozpoczynanie...')
                   .addClass('w-100-mobile');
        
        // Clear any previous status
        $('#export-status').remove();
        
        // Submit form via AJAX
        $.ajax({
            url: $(this).attr('action') || '/export-data/',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRFToken': $('[name="csrfmiddlewaretoken"]').val()
            },
            success: function(response) {
                if (response.success) {
                    currentJobId = response.job_id;
                    showExportStatus(response.message);
                    startPolling(currentJobId);
                } else {
                    showError(response.error || 'Błąd podczas rozpoczynania eksportu');
                    resetSubmitButton(submitButton);
                    isSubmitting = false; // Reset race condition protection
                }
            },
            error: function(xhr) {
                let errorMsg = 'Wystąpił błąd podczas rozpoczynania eksportu';
                try {
                    const response = JSON.parse(xhr.responseText);
                    errorMsg = response.error || errorMsg;
                } catch(e) {
                    // Use default message
                }
                showError(errorMsg);
                resetSubmitButton(submitButton);
                isSubmitting = false; // Reset race condition protection
            }
        });
    });
    
    function startPolling(jobId) {
        // Reset polling attempts counter for new job
        pollingAttempts = 0;
        
        // Poll every 3 seconds
        pollingInterval = setInterval(function() {
            checkExportStatus(jobId);
        }, 3000);
        
        // Check immediately
        checkExportStatus(jobId);
    }
    
    function checkExportStatus(jobId) {
        // Increment polling attempts counter
        pollingAttempts++;
        
        // Check if we've exceeded maximum polling attempts
        if (pollingAttempts > MAX_POLLING_ATTEMPTS) {
            clearInterval(pollingInterval);
            pollingInterval = null;
            
            showTimeoutError();
            resetSubmitButton($('#export-submit-btn'));
            isSubmitting = false;
            return;
        }
        
        $.ajax({
            url: `/data-export-status/${jobId}/`,
            type: 'GET',
            success: function(response) {
                updateExportStatus(response);
                
                // Stop polling if job is finished (success, failure, or file deleted)
                if (response.status === 'SUCCESS' || response.status === 'FAILURE' || response.status === 'FILE_DELETED') {
                    clearInterval(pollingInterval);
                    pollingInterval = null;
                    
                    // Re-enable submit button for new exports
                    resetSubmitButton($('#export-submit-btn'));
                    
                    // Reset race condition protection
                    isSubmitting = false;
                    
                    // If export failed or file was deleted, clear currentJobId
                    if (response.status === 'FAILURE' || response.status === 'FILE_DELETED') {
                        currentJobId = null;
                    }
                }
            },
            error: function() {
                console.error('Error checking export status');
                // Don't stop polling on error - could be temporary
            }
        });
    }
    
    function showExportStatus(message) {
        const statusHtml = `
            <div id="export-status" class="alert alert-info mt-3">
                <div class="d-flex align-items-center">
                    <i class="mdi mdi-information me-2"></i>
                    <div class="flex-grow-1">
                        <div id="status-message">${message}</div>
                    </div>
                </div>
            </div>
        `;
        
        $('.card-body form').after(statusHtml);
        
        // Scroll to the status bar with smooth animation
        // Add small delay to ensure element is rendered
        setTimeout(function() {
            const statusElement = document.getElementById('export-status');
            if (statusElement) {
                // Calculate position: element top minus some margin for better visibility
                const elementTop = statusElement.offsetTop;
                const offset = 100; // Adjust this value to control how much space above status bar
                const scrollPosition = Math.max(0, elementTop - offset);
                
                // Smooth scroll to position
                window.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth'
                });
            }
        }, 100);
    }
    
    function updateExportStatus(data) {
        const statusElement = $('#export-status');
        const messageElement = $('#status-message');
        const iconElement = statusElement.find('i');
        
        if (!statusElement.length) return;
        
        // Update message based on status
        let message = '';
        let alertClass = 'alert-info';
        let iconClass = 'mdi-information';
        
        switch(data.status) {
            case 'PENDING':
                message = 'Zadanie czeka w kolejce...';
                alertClass = 'alert-info';
                iconClass = 'mdi-clock-outline';
                break;
            case 'STARTED':
                message = 'Generowanie pliku w toku...';
                alertClass = 'alert-info';
                iconClass = 'mdi-loading mdi-spin';
                break;
            case 'SUCCESS':
                message = `
                    <div class="d-flex justify-content-between align-items-center">
                        <span>Eksport zakończony pomyślnie!</span>
                        <a href="${data.download_url}" download class="btn btn-success btn-sm w-100-mobile">
                            <i class="mdi mdi-download me-1"></i>Pobierz plik
                        </a>
                    </div>
                `;
                alertClass = 'alert-success';
                iconClass = 'mdi-check-circle';
                break;
            case 'FAILURE':
                message = `Eksport nie powiódł się: ${data.error_message || 'Nieznany błąd'}`;
                alertClass = 'alert-danger';
                iconClass = 'mdi-alert-circle';
                break;
            case 'FILE_DELETED':
                message = 'Poprzedni eksport wygasł lub został usunięty. Rozpocznij nowy eksport.';
                alertClass = 'alert-warning';
                iconClass = 'mdi-delete-circle';
                break;
        }
        
        // Update status alert
        statusElement.removeClass('alert-info alert-warning alert-success alert-danger')
                    .addClass(alertClass);
        
        // Update icon
        iconElement.attr('class', `mdi ${iconClass} me-2`);
        
        messageElement.html(message);
    }
    
    function showError(message) {
        $('#export-status').remove();
        
        const errorHtml = `
            <div id="export-status" class="alert alert-danger mt-3">
                <i class="mdi mdi-alert-circle me-2"></i>
                ${message}
            </div>
        `;
        
        $('.card-body form').after(errorHtml);
        
        // Auto-hide error after 5 seconds
        setTimeout(function() {
            $('#export-status').fadeOut();
        }, 5000);
    }
    
    function resetSubmitButton(button) {
        button.prop('disabled', false)
              .html('<i class="mdi mdi-download me-1"></i>Rozpocznij eksport')
              .addClass('w-100-mobile');
    }
    
    function cleanupPreviousExport() {
        if (currentJobId) {
            // Show brief cleanup message

            $.ajax({
                url: `/cleanup-export/${currentJobId}/`,
                type: 'POST',
                data: {
                    'csrfmiddlewaretoken': $('[name="csrfmiddlewaretoken"]').val()
                },
                async: false, // Synchronous to ensure cleanup happens before new export
            });
            currentJobId = null; // Clear the job ID
        }
    }
    
    // Cleanup on page unload - remove file when leaving export page
    $(window).on('beforeunload', function() {
        // Stop polling
        if (pollingInterval) {
            clearInterval(pollingInterval);
        }
        
        // Clean up export file when leaving the page
        if (currentJobId) {
            // Use sendBeacon for reliable delivery during page unload
            const cleanupData = new FormData();
            cleanupData.append('csrfmiddlewaretoken', $('[name="csrfmiddlewaretoken"]').val());
            
            // sendBeacon is asynchronous and doesn't block page unload
            navigator.sendBeacon(`/cleanup-export/${currentJobId}/`, cleanupData);
        }
    });
    
    function showTimeoutError() {
        const timeoutHtml = `
            <div id="export-status" class="alert alert-danger mt-3">
                <div class="d-flex align-items-center">
                    <i class="mdi mdi-clock-alert me-2"></i>
                    <div>
                        <strong>Przekroczono maksymalny czas eksportu</strong><br>
                        <small>Spróbuj ponownie używając przycisku powyżej lub skontaktuj się z administratorem.</small>
                    </div>
                </div>
            </div>
        `;
        
        $('#export-status').remove();
        $('.card-body form').after(timeoutHtml);
    }
});